import React from "react";
import { ConfirmDialog } from "components/main/utils/ConfirmDialog";
import { useBoundStore } from "components/canvas/stores/useAppStore";

export const ColumnConflictDialog: React.FC = () => {
  const conflict = useBoundStore((state) => state.conflictDialog);
  const clientApp = useBoundStore((state) => state.clientApp);

  const handleConfirm = () => {
    try {
      clientApp?.confirm_waiting_action();
    } catch (e) {
      console.error("Failed to confirm action:", e);
    }
    useBoundStore.getState().setConflictDialog(null);
  };

  const handleCancel = () => {
    try {
      clientApp?.discard_waiting_action();
    } catch (e) {
      console.error("Failed to discard action:", e);
    }
    useBoundStore.getState().setConflictDialog(null);
  };

  return (
    <ConfirmDialog
      open={conflict !== null}
      title={conflict?.title ?? "Conflict"}
      message={conflict?.message ?? ""}
      confirmText="Force Remove"
      cancelText="Cancel"
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );
};
